/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getELAdminEventLog = /* GraphQL */ `
  query GetELAdminEventLog($adminUser: String!, $timestamp: String!) {
    getELAdminEventLog(adminUser: $adminUser, timestamp: $timestamp) {
      adminUser
      timestamp
      action
      exchangeInstrument
      tradeAccount
      symbol
      balance
      leverage
      targetAdminUser
      permission
      description
      createdAt
      updatedAt
    }
  }
`;
export const listELAdminEventLogs = /* GraphQL */ `
  query ListELAdminEventLogs(
    $adminUser: String
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelELAdminEventLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listELAdminEventLogs(
      adminUser: $adminUser
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        adminUser
        timestamp
        action
        exchangeInstrument
        tradeAccount
        symbol
        balance
        leverage
        targetAdminUser
        permission
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listELAdminEventLogsByTradeAccount = /* GraphQL */ `
  query ListELAdminEventLogsByTradeAccount(
    $tradeAccount: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelELAdminEventLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listELAdminEventLogsByTradeAccount(
      tradeAccount: $tradeAccount
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        adminUser
        timestamp
        action
        exchangeInstrument
        tradeAccount
        symbol
        balance
        leverage
        targetAdminUser
        permission
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getModelBacktestKPI = /* GraphQL */ `
  query GetModelBacktestKPI($symbol: String!, $timestamp_15mPointNum: String!) {
    getModelBacktestKPI(
      symbol: $symbol
      timestamp_15mPointNum: $timestamp_15mPointNum
    ) {
      symbol
      timestamp_15mPointNum
      description
      interval
      exchange
      timestamp
      datetime
      fifteenMinPointNum
      leverage
      testPointNumber
      cumulativeReturn
      cumulativePositionChange
      cumulativeReturn1BPS
      cumulativeReturn1_5BPS
      cumulativeReturn2BPS
      cumulativeReturn3BPS
      leverageReturn
      profitPercent
      dailyGrowthRate
      volatility
      sharpeRatio
      sortinoRatio
      maxDrawDown
      calmarRatio
      modelName1
      modelName2
      isDeactivated
    }
  }
`;
export const listModelBacktestKPIS = /* GraphQL */ `
  query ListModelBacktestKPIS(
    $symbol: String
    $timestamp_15mPointNum: ModelStringKeyConditionInput
    $filter: ModelModelBacktestKPIFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listModelBacktestKPIS(
      symbol: $symbol
      timestamp_15mPointNum: $timestamp_15mPointNum
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        symbol
        timestamp_15mPointNum
        description
        interval
        exchange
        timestamp
        datetime
        fifteenMinPointNum
        leverage
        testPointNumber
        cumulativeReturn
        cumulativePositionChange
        cumulativeReturn1BPS
        cumulativeReturn1_5BPS
        cumulativeReturn2BPS
        cumulativeReturn3BPS
        leverageReturn
        profitPercent
        dailyGrowthRate
        volatility
        sharpeRatio
        sortinoRatio
        maxDrawDown
        calmarRatio
        modelName1
        modelName2
        isDeactivated
      }
      nextToken
    }
  }
`;
export const getTradeSymbols = /* GraphQL */ `
  query GetTradeSymbols($symbol: String!) {
    getTradeSymbols(symbol: $symbol) {
      symbol
      lastPredictedAt
      isVolatileSymbol
      binanceUsdsFutureContractDecimal
      binanceCoinFutureContractDecimal
      huobiUsdtSwapContractDecimal
      huobiCoinSwapContractDecimal
      huobiFutureContractDecimal
      ifFetchForPrediction
      ifFetchForTraining
      ifRunScheduledEvaluation
      ifDisplayInAdmin
    }
  }
`;
export const listTradeSymbols = /* GraphQL */ `
  query ListTradeSymbols(
    $symbol: String
    $filter: ModelTradeSymbolsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTradeSymbols(
      symbol: $symbol
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        symbol
        lastPredictedAt
        isVolatileSymbol
        binanceUsdsFutureContractDecimal
        binanceCoinFutureContractDecimal
        huobiUsdtSwapContractDecimal
        huobiCoinSwapContractDecimal
        huobiFutureContractDecimal
        ifFetchForPrediction
        ifFetchForTraining
        ifRunScheduledEvaluation
        ifDisplayInAdmin
      }
      nextToken
    }
  }
`;
export const getExchangeAccountBalance = /* GraphQL */ `
  query GetExchangeAccountBalance(
    $exchangeAccount: String!
    $timestamp: String!
  ) {
    getExchangeAccountBalance(
      exchangeAccount: $exchangeAccount
      timestamp: $timestamp
    ) {
      exchangeAccount
      timestamp
      type
      parentAccount
      balances
      tradeSessions
    }
  }
`;
export const listExchangeAccountBalances = /* GraphQL */ `
  query ListExchangeAccountBalances(
    $exchangeAccount: String
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelExchangeAccountBalanceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listExchangeAccountBalances(
      exchangeAccount: $exchangeAccount
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        exchangeAccount
        timestamp
        type
        parentAccount
        balances
        tradeSessions
      }
      nextToken
    }
  }
`;
export const getCognitoAdminPermission = /* GraphQL */ `
  query GetCognitoAdminPermission($email: String!) {
    getCognitoAdminPermission(email: $email) {
      email
      isEnabled
      username
      groups
      role
      managedAccounts {
        name
        permissions
      }
      enabledPermissions
      tradeAccountGroups {
        name
        includedAccounts
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCognitoAdminPermissions = /* GraphQL */ `
  query ListCognitoAdminPermissions(
    $email: String
    $filter: ModelCognitoAdminPermissionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCognitoAdminPermissions(
      email: $email
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        email
        isEnabled
        username
        groups
        role
        managedAccounts {
          name
          permissions
        }
        enabledPermissions
        tradeAccountGroups {
          name
          includedAccounts
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCognitoAdminPermissionByUsername = /* GraphQL */ `
  query GetCognitoAdminPermissionByUsername(
    $username: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCognitoAdminPermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCognitoAdminPermissionByUsername(
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        email
        isEnabled
        username
        groups
        role
        managedAccounts {
          name
          permissions
        }
        enabledPermissions
        tradeAccountGroups {
          name
          includedAccounts
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTradeAccountStatus = /* GraphQL */ `
  query GetTradeAccountStatus($exchange: String!, $accountSymbol: String!) {
    getTradeAccountStatus(exchange: $exchange, accountSymbol: $accountSymbol) {
      exchange
      accountSymbol
      sessionName
      contactNumbers
      type
      isTrading
      enableMonitoring
      executingCommand
      status
      symbol
      modes
      configs
      leverage
      practicalLeverage
      leverageScaleFactor
      currentState
      errorMessage
      walletBalance
      marginBalance
      usedBalance
      entireBalanceList
      parentAccount
      algoParams
      algoTrades
      info
      arbitrageMarginAmt
      arbitrageUsdmAmt
      arbitrageParams
      tradingHoursParams
      createdAt
      updatedAt
    }
  }
`;
export const listTradeAccountStatuses = /* GraphQL */ `
  query ListTradeAccountStatuses(
    $exchange: String
    $accountSymbol: ModelStringKeyConditionInput
    $filter: ModelTradeAccountStatusFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTradeAccountStatuses(
      exchange: $exchange
      accountSymbol: $accountSymbol
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        exchange
        accountSymbol
        sessionName
        contactNumbers
        type
        isTrading
        enableMonitoring
        executingCommand
        status
        symbol
        modes
        configs
        leverage
        practicalLeverage
        leverageScaleFactor
        currentState
        errorMessage
        walletBalance
        marginBalance
        usedBalance
        entireBalanceList
        parentAccount
        algoParams
        algoTrades
        info
        arbitrageMarginAmt
        arbitrageUsdmAmt
        arbitrageParams
        tradingHoursParams
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMonitoringAccounts = /* GraphQL */ `
  query GetMonitoringAccounts($exchange: String!, $account: String!) {
    getMonitoringAccounts(exchange: $exchange, account: $account) {
      exchange
      account
      alertNumbers
      disableMonitor
      symbols
      parentAccount
      type
    }
  }
`;
export const listMonitoringAccounts = /* GraphQL */ `
  query ListMonitoringAccounts(
    $exchange: String
    $account: ModelStringKeyConditionInput
    $filter: ModelMonitoringAccountsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMonitoringAccounts(
      exchange: $exchange
      account: $account
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        exchange
        account
        alertNumbers
        disableMonitor
        symbols
        parentAccount
        type
      }
      nextToken
    }
  }
`;
export const getModelPrediction = /* GraphQL */ `
  query GetModelPrediction($modelName: String!, $timeStamp: String!) {
    getModelPrediction(modelName: $modelName, timeStamp: $timeStamp) {
      modelName
      timeStamp
      predictValue
      interval
      intervalInMillisec
      symbol
      targetModelId
    }
  }
`;
export const listModelPredictions = /* GraphQL */ `
  query ListModelPredictions(
    $modelName: String
    $timeStamp: ModelStringKeyConditionInput
    $filter: ModelModelPredictionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listModelPredictions(
      modelName: $modelName
      timeStamp: $timeStamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        modelName
        timeStamp
        predictValue
        interval
        intervalInMillisec
        symbol
        targetModelId
      }
      nextToken
    }
  }
`;
export const getTradeModels = /* GraphQL */ `
  query GetTradeModels($modelName1: String!, $modelName2: String!) {
    getTradeModels(modelName1: $modelName1, modelName2: $modelName2) {
      modelName1
      modelName2
      disabled
      symbol
      temporarilyDisabledSymbols
      tradingSymbols
    }
  }
`;
export const listTradeModels = /* GraphQL */ `
  query ListTradeModels(
    $modelName1: String
    $modelName2: ModelStringKeyConditionInput
    $filter: ModelTradeModelsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTradeModels(
      modelName1: $modelName1
      modelName2: $modelName2
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        modelName1
        modelName2
        disabled
        symbol
        temporarilyDisabledSymbols
        tradingSymbols
      }
      nextToken
    }
  }
`;
export const getPartnerPrediction = /* GraphQL */ `
  query GetPartnerPrediction($modelName: String!, $timestamp: String!) {
    getPartnerPrediction(modelName: $modelName, timestamp: $timestamp) {
      modelName
      timestamp
      data
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPartnerPredictions = /* GraphQL */ `
  query ListPartnerPredictions(
    $modelName: String
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelPartnerPredictionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPartnerPredictions(
      modelName: $modelName
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        modelName
        timestamp
        data
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getTouchstoneSubmissions = /* GraphQL */ `
  query GetTouchstoneSubmissions($system: String!, $ts_created: Float!) {
    getTouchstoneSubmissions(system: $system, ts_created: $ts_created) {
      system
      submission_id
      gsi_pk
      owner
      sources
      status
      queue_position
      results
      description
      ts_created
      ts_queued
      ts_finished
      console_log_tail
    }
  }
`;
export const listTouchstoneSubmissions = /* GraphQL */ `
  query ListTouchstoneSubmissions(
    $system: String
    $ts_created: ModelFloatKeyConditionInput
    $filter: ModelTouchstoneSubmissionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTouchstoneSubmissions(
      system: $system
      ts_created: $ts_created
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        system
        submission_id
        gsi_pk
        owner
        sources
        status
        queue_position
        results
        description
        ts_created
        ts_queued
        ts_finished
        console_log_tail
      }
      nextToken
    }
  }
`;
export const listTouchstoneSubmissionsById = /* GraphQL */ `
  query ListTouchstoneSubmissionsById(
    $submission_id: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTouchstoneSubmissionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTouchstoneSubmissionsById(
      submission_id: $submission_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        system
        submission_id
        gsi_pk
        owner
        sources
        status
        queue_position
        results
        description
        ts_created
        ts_queued
        ts_finished
        console_log_tail
      }
      nextToken
    }
  }
`;
export const listTouchstoneSubmissionsByTsCreated = /* GraphQL */ `
  query ListTouchstoneSubmissionsByTsCreated(
    $gsi_pk: String!
    $ts_created: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTouchstoneSubmissionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTouchstoneSubmissionsByTsCreated(
      gsi_pk: $gsi_pk
      ts_created: $ts_created
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        system
        submission_id
        gsi_pk
        owner
        sources
        status
        queue_position
        results
        description
        ts_created
        ts_queued
        ts_finished
        console_log_tail
      }
      nextToken
    }
  }
`;
export const getTouchstoneTasks = /* GraphQL */ `
  query GetTouchstoneTasks($submission_id: String!, $task_id: String!) {
    getTouchstoneTasks(submission_id: $submission_id, task_id: $task_id) {
      submission_id
      task_id
      gsi_pk
      artifacts
      desired_resource
      resource
      config_file
      el_nigma_branch
      sources
      pred_interval
      fetched_data_end_to
      passthrough_args
      status
      status_timestamp
      epochs_completed
      epochs_timestamp
      console_log_tail
      console_log_url
      ts_task_started
      ts_task_finished
      ts_training_started
      ts_training_finished
      type
    }
  }
`;
export const listTouchstoneTasks = /* GraphQL */ `
  query ListTouchstoneTasks(
    $submission_id: String
    $task_id: ModelStringKeyConditionInput
    $filter: ModelTouchstoneTasksFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTouchstoneTasks(
      submission_id: $submission_id
      task_id: $task_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        submission_id
        task_id
        gsi_pk
        artifacts
        desired_resource
        resource
        config_file
        el_nigma_branch
        sources
        pred_interval
        fetched_data_end_to
        passthrough_args
        status
        status_timestamp
        epochs_completed
        epochs_timestamp
        console_log_tail
        console_log_url
        ts_task_started
        ts_task_finished
        ts_training_started
        ts_training_finished
        type
      }
      nextToken
    }
  }
`;
export const listTouchstoneTasksByTimestamp = /* GraphQL */ `
  query ListTouchstoneTasksByTimestamp(
    $gsi_pk: String!
    $status_timestamp: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTouchstoneTasksFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTouchstoneTasksByTimestamp(
      gsi_pk: $gsi_pk
      status_timestamp: $status_timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        submission_id
        task_id
        gsi_pk
        artifacts
        desired_resource
        resource
        config_file
        el_nigma_branch
        sources
        pred_interval
        fetched_data_end_to
        passthrough_args
        status
        status_timestamp
        epochs_completed
        epochs_timestamp
        console_log_tail
        console_log_url
        ts_task_started
        ts_task_finished
        ts_training_started
        ts_training_finished
        type
      }
      nextToken
    }
  }
`;
export const listTouchstoneTasksByStatus = /* GraphQL */ `
  query ListTouchstoneTasksByStatus(
    $status: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTouchstoneTasksFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTouchstoneTasksByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        submission_id
        task_id
        gsi_pk
        artifacts
        desired_resource
        resource
        config_file
        el_nigma_branch
        sources
        pred_interval
        fetched_data_end_to
        passthrough_args
        status
        status_timestamp
        epochs_completed
        epochs_timestamp
        console_log_tail
        console_log_url
        ts_task_started
        ts_task_finished
        ts_training_started
        ts_training_finished
        type
      }
      nextToken
    }
  }
`;
export const getSystemConfig = /* GraphQL */ `
  query GetSystemConfig($category: String!, $keyname: String!) {
    getSystemConfig(category: $category, keyname: $keyname) {
      category
      keyname
      value
    }
  }
`;
export const listSystemConfigs = /* GraphQL */ `
  query ListSystemConfigs(
    $category: String
    $keyname: ModelStringKeyConditionInput
    $filter: ModelSystemConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSystemConfigs(
      category: $category
      keyname: $keyname
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        category
        keyname
        value
      }
      nextToken
    }
  }
`;
export const listTradeSessions = /* GraphQL */ `
  query ListTradeSessions {
    listTradeSessions {
      response
    }
  }
`;
export const getTradeSessionsServerStatus = /* GraphQL */ `
  query GetTradeSessionsServerStatus {
    getTradeSessionsServerStatus {
      response
    }
  }
`;
export const listWalletBalances = /* GraphQL */ `
  query ListWalletBalances($query: QueryListWalletBalancesQueryInput!) {
    listWalletBalances(query: $query)
  }
`;
export const listManagedTradeAccountStatus = /* GraphQL */ `
  query ListManagedTradeAccountStatus {
    listManagedTradeAccountStatus {
      groupName
      parsedTradeAccountStatusList {
        tradeAccountStatus {
          exchange
          accountSymbol
          sessionName
          contactNumbers
          type
          isTrading
          enableMonitoring
          executingCommand
          status
          symbol
          modes
          configs
          leverage
          practicalLeverage
          leverageScaleFactor
          currentState
          errorMessage
          walletBalance
          marginBalance
          usedBalance
          entireBalanceList
          parentAccount
          algoParams
          algoTrades
          info
          arbitrageMarginAmt
          arbitrageUsdmAmt
          arbitrageParams
          tradingHoursParams
          createdAt
          updatedAt
        }
        account
        parentAccount
        symbolShort
        exchangeId
        exchangeAccount
        key
        parsedConfigs
        parsedModes
        permissions
      }
    }
  }
`;
export const getRsaPublicKey = /* GraphQL */ `
  query GetRsaPublicKey {
    getRsaPublicKey
  }
`;
